module.exports = __webpack_public_path__ + "static/img/guide_step_4.eb7675fb.png";